<div
  class="flex-left-column light-control-host"
  data-cy="conclude-recovery-dialog"
  arpSurfaceErrorHost="conclude-recovery-dialog"
  #dialogError="surfaceErrorHost"
>
  <div class="modal-header">
    <h3 class="panel-title" data-cy="dialog-title">{{ dialogTitle }}</h3>
    <button
      type="button"
      class="modal-close-btn"
      (click)="onCancelClick()"
      pTooltip="Close"
      tooltipPosition="left"
      aria-label="Close"
    >
      <svg lucideX></svg>
    </button>
  </div>
  <div class="modal-subtitle">
    Concluding recovery disposes of resources in the recovery region and returns the application to a standby state. Do
    not proceed until you no longer need these resources.
  </div>

  <div class="modal-step">
    <div class="modal-step-label">
      <span class="modal-step-number"></span>
      <h3 class="modal-step-title">Applications in {{ !!application ? application.targetRegion : '' }}</h3>
      @if (applications.length > 0 || hasAnyInProgressCandidate) {
        <div class="modal-step-actions">
          @if (hasAnyInProgressCandidate) {
            <label class="show-only-completed-toggle">
              <input
                class="arpio-checkbox"
                type="checkbox"
                data-cy="show-only-completed-toggle"
                [(ngModel)]="showOnlyCompleted"
                [disabled]="launching"
              />
              Show only completed
            </label>
          }
          @if (applications.length > 0) {
            <span class="selection-count">
              <strong>{{ selectedApplications.length }}</strong> of {{ applications.length }} selected
            </span>
            <button
              type="button"
              class="select-all-link"
              (click)="toggleSelectAllApplications(!areAllApplicationsSelected())"
              [disabled]="launching"
            >
              {{ areAllApplicationsSelected() ? 'Deselect all' : 'Select all' }}
            </button>
          }
        </div>
      }
    </div>
    <!-- "Show only completed" can hide every row when nothing has finished restoring; keep the
         toggle reachable above and surface a hint here so the user isn't stranded. -->
    @if (applications.length === 0 && showOnlyCompleted && hasAnyInProgressCandidate) {
      <div class="app-selection-empty" data-cy="no-completed-empty-state">
        <svg lucideInfo></svg>
        <span
          >No applications have finished restoring yet. Uncheck “Show only completed” to act on the in-progress
          applications.</span
        >
      </div>
    }
    @if (applications.length > 0) {
      <div id="applicationSelectionList" class="app-selection-list">
        @for (application of applications; track applicationTrackBy($index, application)) {
          <label
            class="app-selection-row"
            [class.selected]="applicationIsChecked(application.applicationObj)"
            [attr.data-cy]="'app-row-' + application.applicationObj.applicationId"
          >
            <input
              class="arpio-checkbox"
              type="checkbox"
              (input)="toggleApplicationSelection(application.applicationObj.applicationId)"
              [checked]="applicationIsChecked(application.applicationObj)"
              [disabled]="launching"
            />
            <span class="app-name">{{ application.applicationObj.name }}</span>
            <span
              class="app-restore-status"
              data-cy="app-restore-status"
              [class.app-restore-status--in-progress]="statusInfoFor(application.applicationObj).inProgress"
            >
              @if (statusInfoFor(application.applicationObj).inProgress) {
                <svg lucideLoaderCircle class="lucide-spin"></svg>
              }
              {{ statusInfoFor(application.applicationObj).label }}
            </span>
          </label>
        }
      </div>
    }
  </div>

  @if (hasMixedSelection) {
    <div class="notice-warning conclude-disclaimer" data-cy="mixed-disclaimer">
      <svg lucideCircleAlert></svg>
      <p>
        <strong>{{ cancelledAppNames }}</strong>
        {{ selectedToCancel.length === 1 ? 'is' : 'are' }} still mid-restore and will be cancelled rather than
        concluded. Conclude will apply normally to <strong>{{ concludedAppNames }}</strong
        >.
      </p>
    </div>
  }

  @if (allSelectedWillBeCancelled) {
    <div class="notice-warning conclude-disclaimer" data-cy="all-cancel-disclaimer">
      <svg lucideCircleAlert></svg>
      <p>
        <strong>{{ cancelledAppNames }}</strong>
        {{ selectedToCancel.length === 1 ? 'is' : 'are' }} still mid-restore. Submitting will cancel
        {{ selectedToCancel.length === 1 ? 'this recovery' : 'these recoveries' }} and return the
        {{ selectedToCancel.length === 1 ? 'application' : 'applications' }} to standby.
      </p>
    </div>
  }

  @if (currentlySyncing) {
    <div class="syncing-banner">
      <svg lucideLoaderCircle class="lucide-spin"></svg>
      <p>Arpio is launching a recovery. Once it's done, you will be able to conclude your recovery.</p>
    </div>
  }

  @if (dialogError.error) {
    <arp-error-block
      class="dialog-error"
      [error]="dialogError.error"
      [dismissible]="true"
      (dismissed)="dialogError.clear()"
    ></arp-error-block>
  }

  <div class="modal-footer">
    @if (dialogError.error?.blockedReason) {
      <span class="modal-footer-hint">{{ dialogError.error.blockedReason }}</span>
    }
    <button
      class="arpio-secondary-button"
      data-cy="dialog-cancel-button"
      (click)="onCancelClick()"
      [disabled]="launching"
    >
      Cancel
    </button>
    <!-- Two static-label buttons (only one renders) instead of one dynamic label: busy-button
         snapshots its content on init, so a label that flips after open would otherwise stay stale. -->
    @if (allSelectedWillBeCancelled) {
      <button
        busy-button
        [busy]="launching"
        id="conclude-button"
        data-cy="submit-button"
        class="arpio-button"
        (click)="onConcludeClick()"
        [disabled]="!canSubmit || launching || !!dialogError.error?.blockedReason"
      >
        Cancel Recovery
      </button>
    }
    @if (!allSelectedWillBeCancelled) {
      <button
        busy-button
        [busy]="launching"
        id="conclude-button"
        data-cy="submit-button"
        class="arpio-button"
        (click)="onConcludeClick()"
        [disabled]="!canSubmit || launching || !!dialogError.error?.blockedReason"
      >
        Conclude Recovery
      </button>
    }
  </div>
</div>
